import * as React from "react";

import { constants } from "../../../../../store/invoicingCustomer";

import ContractCostsBase from "../../../Costs/ContractCostsBase";

export default ({
  method,
  skipInvoicing,
  goBackToInvoicingSetup,
  contract,
}) => {
  return (
    <ContractCostsBase
      {...{
        method,
        skipInvoicing,
        goBackToInvoicingSetup,
        contract,
        constants,
      }}
    />
  );
};
